import { useModal } from '@/hooks/useModal';
import ModalDrawer from './ModalDrawer';

export const GlobalModal = () => {
	const {
		isOpen,
		content,
		title,
		size,
		mobileSheet,
		closeModal,
		onConfirm,
		cancelText,
		confirmText,
		isDisabledConfirm,
	} = useModal();

	return (
		<ModalDrawer
			isOpen={isOpen}
			onCancel={closeModal}
			onSuccess={onConfirm}
			title={title}
			cancelText={cancelText}
			successText={confirmText}
			disabledConfirm={isDisabledConfirm}
			size={size}
			mobileSheet={mobileSheet}
		>
			{content}
		</ModalDrawer>
	);
};
